module.exports = __webpack_public_path__ + "odstraneni-tetovaze_4_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/odstraneni-tetovaze_4_before_tn.jpg
// module id = 1428
// module chunks = 0